import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Translator } from 'angular-translator';
import { Marketplace } from 'app/infrastructure/model/classes/marketplace.class';
import {
  MarketplaceService,
  MARKETPLACE_ITEMTYPE_AllOfThem,
} from 'app/infrastructure/services/marketplace.service';
import { OpcionCheckeable } from 'app/infrastructure/services/selects.service';

@Component({
  selector: 'marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss'],
})
export class MarketplaceComponent implements OnInit {
  marketplaceItems: Marketplace[];
  marketplaceItemsFiltered: Marketplace[];
  organizations: OpcionCheckeable[];
  expand: boolean;
  id: any;

  constructor(
    public router: Router,
    protected route: ActivatedRoute,
    public translate: Translator,
    private marketplaceService: MarketplaceService
  ) {}

  ngOnInit() {
    this.marketplaceService
      .getMarketplaces([MARKETPLACE_ITEMTYPE_AllOfThem])
      .subscribe(
        (response) => (
          (this.marketplaceItems = response),
          (this.marketplaceItemsFiltered = this.shuffle(this.marketplaceItems))
        )
      );
  }

  shuffle(array: any[]) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  goBack() {
    this.router.navigate(['../'], { relativeTo: this.route.parent });
  }

  filtersEvent(filters: any) {
    const search = filters.search;
    const types = filters.types;
    const organizations = filters.organizations;

    if (types.length > 0 && search !== '') {
      this.marketplaceItemsFiltered = this.marketplaceItems.filter(
        (item) =>
          (item.description.toLowerCase().includes(search.toLowerCase()) ||
            item.type.toLowerCase().includes(search.toLowerCase()) ||
            item.title.toLowerCase().includes(search.toLowerCase())) &&
          types.includes(item.type)
      );
    } else if (types.length > 0) {
      this.marketplaceItemsFiltered = this.marketplaceItems.filter((item) =>
        types.includes(item.type)
      );
    } else if (search !== '') {
      this.marketplaceItemsFiltered = this.marketplaceItems.filter(
        (item) =>
          item.description.toLowerCase().includes(search.toLowerCase()) ||
          item.type.toLowerCase().includes(search.toLowerCase())
      );
    } else {
      this.marketplaceItemsFiltered = this.marketplaceItems;
    }
  }

  isExpanded(event) {
    this.id = event.id;
    this.expand = event.expand;
  }

  // Only delete de render element, dont persist on database
  deleteEvent(model: Marketplace) {
    this.expand = false;
    this.marketplaceItemsFiltered = this.marketplaceItems.filter(
      (m) => m.id != model.id
    );
    this.marketplaceItems = this.marketplaceItems.filter(
      (m) => m.id != model.id
    );
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/marketplace/marketplace.component.ts